import React from "react";
import styled from "styled-components";

import { useRecommendationContext } from "../context/RecommendationContext";
import Error from "./Error";
import Loading from "./Loading";
import OutfitCanvas from "./OutfitCanvas";
import SectionHeader from "./SectionHeader";

const CompleteTheLook = (props: any) => {
  const { className, title, recommendations } = props;
  const { styleRecsLoading, styleRecsError } = useRecommendationContext();

  if (styleRecsLoading) {
    return <Loading />;
  }
  if (styleRecsError) {
    return <Error />;
  }

  return (
    <>
      {title && <SectionHeader title={title} fontSize={24} />}
      <Recommendations className={className}>
        {recommendations.map((item: any, i: number) => (
          <Item key={i} item={item} />
        ))}
      </Recommendations>
    </>
  );
};

function Item(props: any) {
  return (
    <OutfitContainer>
      <OutfitCanvas key={props.i} recommendation={props.item} />
    </OutfitContainer>
  );
}

const OutfitContainer = styled.article`
  display: inline-block;
`;

const Recommendations = styled.div`
  overflow-x: auto;
  white-space: nowrap;

  article {
    margin: 0 1vw;
  }

  article:first-of-type {
    margin-left: 0;
  }

  article:last-of-type {
    margin-right: 0;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #d8d8d8;
  }

  ::-webkit-scrollbar {
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #2c2c2c;
  }
`;

export default CompleteTheLook;
